import LibLoader from './LibLoader'
const url = 'https://ucarecdn.com/widget/2.8.2/uploadcare/uploadcare.full.min.js'

export default new LibLoader('Uploadcare', url, 'uploadcare')
